import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { LanguageProvider } from './contexts/LanguageContext';
import { Toaster } from './components/ui/sonner';
import './App.css';

import ProtectedRoute from './components/ProtectedRoute';
import PortalLayout from './components/PortalLayout';
import ProtectedAdminRoute from './components/ProtectedAdminRoute';
import AdminLayout from './components/AdminLayout';

// Auth Pages
import Login from './pages/Login';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';

// Portal Pages
import Dashboard from './pages/portal/Dashboard';
import TreatmentHistory from './pages/portal/TreatmentHistory';
import PaymentRecords from './pages/portal/PaymentRecords';
import MedicalHistory from './pages/portal/MedicalHistory';
import BookAppointment from './pages/portal/BookAppointment';
import MyScans from './pages/portal/MyScans';
import MedicalTests from './pages/portal/MedicalTests';

// Admin Pages
import AdminLogin from './pages/admin/AdminLogin';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminPatients from './pages/admin/AdminPatients';
import AdminTreatments from './pages/admin/AdminTreatments';
import AdminPayments from './pages/admin/AdminPayments';
import AdminNotifications from './pages/admin/AdminNotifications';
import AdminAppointments from './pages/admin/AdminAppointments';
import AdminMedicalHistory from './pages/admin/AdminMedicalHistory';
import AdminScans from './pages/admin/AdminScans';
import AdminMedicalTests from './pages/admin/AdminMedicalTests';
import AdminSchedule from './pages/admin/AdminSchedule';

function App() {
  return (
    <LanguageProvider>
    <AuthProvider>
      <BrowserRouter>
        <div className="App">
          <Routes>
            {/* Root redirects to login */}
            <Route path="/" element={<Navigate to="/login" replace />} />

            {/* Auth Routes */}
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />

            {/* Protected Portal Routes */}
            <Route
              path="/portal"
              element={
                <ProtectedRoute>
                  <PortalLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Navigate to="/portal/dashboard" replace />} />
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="history" element={<TreatmentHistory />} />
              <Route path="payments" element={<PaymentRecords />} />
              <Route path="book-appointment" element={<BookAppointment />} />
              <Route path="medical-history" element={<MedicalHistory />} />
              <Route path="scans" element={<MyScans />} />
              <Route path="medical-tests" element={<MedicalTests />} />
            </Route>

            {/* Admin Routes */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin"
              element={
                <ProtectedAdminRoute>
                  <AdminLayout />
                </ProtectedAdminRoute>
              }
            >
              <Route index element={<Navigate to="/admin/dashboard" replace />} />
              <Route path="dashboard" element={<AdminDashboard />} />
              <Route path="patients" element={<AdminPatients />} />
              <Route path="treatments" element={<AdminTreatments />} />
              <Route path="payments" element={<AdminPayments />} />
              <Route path="appointments" element={<AdminAppointments />} />
              <Route path="medical-history" element={<AdminMedicalHistory />} />
              <Route path="scans" element={<AdminScans />} />
              <Route path="medical-tests" element={<AdminMedicalTests />} />
              <Route path="notifications" element={<AdminNotifications />} />
              <Route path="schedule" element={<AdminSchedule />} />
            </Route>

            {/* Catch all */}
            <Route path="*" element={<Navigate to="/login" replace />} />
          </Routes>
          <Toaster position="top-right" richColors />
        </div>
      </BrowserRouter>
    </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
